export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13259.f7bf6e10.jpg";